module.exports = __webpack_public_path__ + "img/HZGB10-01.ee489bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB10-01.png
// module id = yTjB
// module chunks = 0